import type Controller from '@ember/controller';
import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

export interface RoutineDetailModel {
	routineId: string;
}

export default class RoutinesDetailRoute extends Route {
	@service('ai-chat') declare aiChatService: Service.AIChat;

	override model(params: Record<string, unknown>): RoutineDetailModel {
		return { routineId: (params as { routine_id: string }).routine_id };
	}

	override setupController(controller: Controller, model: RoutineDetailModel): void {
		super.setupController(controller, model);

		// Drive the routine id from the URL into the nav sidebar's selected-row highlight (hard load + live nav).
		this.aiChatService.applyUrlRoutine(model.routineId);
	}
}
